export default __webpack_public_path__ + "static/media/project_management.10fef463.png";